import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const Breadcrumb = ({ crumbs }) => {
    // Don't render a single breadcrumb.
    if (crumbs.length <= 1) {
        return null;
    }

    return (
        <div className="mb-4 pl-4">
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="Breadcrumb">
                {crumbs.map(({ name, path }, key) =>
                    key + 1 === crumbs.length ? (
                        <Typography
                            style={{ color: "lightslategray" }}
                            key={key}>
                            {name}
                        </Typography>
                    ) : (
                        <Link
                            style={{ color: "white" }}
                            key={key}
                            to={path}>
                            {name}
                        </Link>
                    )
                )}
            </Breadcrumbs>
        </div>
    );
};

export default Breadcrumb;